import React from "react";
import styled from "styled-components";

const FooterContainer = styled.div`
  margin-top: 5em;
  width: 100%;
  padding: 5px 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fafbfc;
`;

const FooterInnerContainer = styled.div`
  max-width: 60%;
  min-width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 3px solid #ddd;
  color: #888;
  font-family: Oxygen, sans-serif;
  font-size: 16px;
  padding: 10px;
  div {
    margin-left: 7px;
    margin-right: 10px;
  }
  a {
    color: #5390c5;
    margin-left: 3px;
    text-decoration: none;
  }
  @media only screen and (max-width: 776px) {
    max-width: 100%;
    min-width: 100%;
    width: 100%;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterInnerContainer>
        <div>© {new Date().getFullYear()}</div>
        <div>
          Created With ️❤️ and 🍫 by
          <a href="https://twitter.com/ipenywis" target="_blank">
            Islem Penywis
          </a>
        </div>
        <div>
          Find Tutorials at{" "}
          <a href="https://ipenywis.com" target="_blank">
            Ipenywis.com
          </a>
        </div>
      </FooterInnerContainer>
    </FooterContainer>
  );
};

export default Footer;
